import React from 'react';
import { Helmet } from 'react-helmet';

const seoValues = {
  title: 'Somali Islamic Society of BC',
  siteName: 'SISBC',
  description:
    'The Somali Islamic Society of BC (SISBC) is a non-profit organization serving the Somali Muslim community in British Columbia.',
  url: 'https://www.sisbc.ca', // No trailing slash allowed!
  // image: "/images/social-share.jpg", // Path to your image you placed in the 'static' folder
  // twitterUsername: "@occlumency",
};

const Seo = () => {
  return (
    <Helmet title={seoValues.title}>
      <html lang="en" />
      <meta name="description" content={seoValues.description} />
      {/* <meta name="image" content={seo.image} /> */}

      {seoValues.url && <meta property="og:url" content={seoValues.url} />}

      <meta property="og:type" content="website" />

      {seoValues.siteName && <meta property="og:site_name" content={seoValues.siteName} />}

      {seoValues.title && <meta property="og:title" content={seoValues.title} />}

      {seoValues.description && (
        <meta property="og:description" content={seoValues.description} />
      )}

      {/* {seo.image && <meta property="og:image" content={seo.image} />} */}

      <meta name="twitter:card" content="summary" />

      {/* {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )} */}

      {seoValues.title && <meta name="twitter:title" content={seoValues.title} />}

      {seoValues.description && (
        <meta name="twitter:description" content={seoValues.description} />
      )}

      {/* {seo.image && <meta name="twitter:image" content={seo.image} />} */}
    </Helmet>
  );
};

export default Seo;
